// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"RegisterForm_checkbox__3TflE"};